import { transformAssetListToTree, } from '@builder/schemas';
export const useAssets = (assetListDSL, assetBackendList) => {
    if (!assetListDSL) {
        return {};
    }
    return transformAssetListToTree(assetListDSL, assetBackendList);
};
